import React, { useEffect, createElement } from 'react';
import { FileText, Zap, BookOpen, AlertCircle, CheckCircle2, XCircle, Star, Settings, Gift } from 'lucide-react';
import { BuyButton } from './components/BuyButton';
import { Accordion } from './components/Accordion';
import { SalesPopup } from './components/SalesPopup';
import { Countdown } from './components/Countdown';
import { Carousel } from './components/Carousel';
export function App() {
  useEffect(() => {
    // Meta Pixel Code Injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1252242806993118');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-[#0b1622] text-slate-200 font-sans selection:bg-[#d4a017] selection:text-[#0b1622]" data-id="element-0">
      <SalesPopup data-id="element-1" />

      {/* HEADER / HERO */}
      <header className="max-w-4xl mx-auto px-4 pt-12 pb-8 text-center" data-id="element-2">
        <h1 className="text-3xl md:text-5xl font-black text-white leading-tight mb-8" data-id="element-3">
          El Plan Físico Que Te Falta Para Entrar al{' '}
          <span className="text-[#f0b429]" data-id="element-4">Cuerpo de Bomberos</span>
        </h1>

        <a href="https://checkout.ebookpoint.shop/cart/59674556596305:1" className="block max-w-2xl mx-auto mb-8 hover:scale-[1.02] transition-transform" data-id="element-5">
          <img src="https://cdn.magicpatterns.com/uploads/weS9Ksqf9yaPJJQPP1czRK/ChatGPT_Image_Jun_18,_2026,_01_09_20_PM.png" alt="Sistema Completo para Bomberos Voluntarios" className="w-full h-auto rounded-xl shadow-2xl shadow-black/50" data-id="element-6" />
        </a>

        <h2 className="text-xl md:text-2xl text-slate-300 font-medium max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-7">
          Un plan progresivo semana por semana para llegar al examen físico con
          el nivel que te van a exigir, sin entrenar a ciegas.
        </h2>

        <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[#112236] px-4 py-2 rounded-full border border-slate-700 mb-10 text-sm" data-id="element-8">
          <span className="flex items-center gap-1.5 font-semibold text-white" data-id="element-9">
            <FileText className="w-4 h-4 text-[#f0b429]" data-id="element-10" /> 100% PDF
          </span>
          <span className="text-slate-600" data-id="element-11">·</span>
          <span className="flex items-center gap-1.5 font-semibold text-white" data-id="element-12">
            <Zap className="w-4 h-4 text-[#f0b429]" data-id="element-13" /> Entrega Inmediata
          </span>
          <span className="text-slate-600" data-id="element-14">·</span>
          <span className="flex items-center gap-1.5 font-semibold text-white" data-id="element-15">
            <BookOpen className="w-4 h-4 text-[#f0b429]" data-id="element-16" /> 10 Módulos + 6 Bonos
          </span>
        </div>

        <BuyButton data-id="element-17" />
      </header>

      {/* PROBLEMATICAS */}
      <section className="max-w-3xl mx-auto px-4 py-12" data-id="element-18">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-19">
          Muchos quieren ser bombero, pero a veces no todos llegan
        </h3>

        <div className="space-y-4 mb-12" data-id="element-20">
          {['Entrenan como si fueran al gimnasio tradicional, pero fallan en las pruebas específicas de fuerza funcional.', 'No logran los tiempos exigidos en el test de Cooper o los 1000 metros por falta de resistencia cardiovascular específica.', 'Se lesionan semanas antes del examen por sobreentrenamiento o mala técnica en los ejercicios.', 'No saben cómo simular el peso del equipo estructural (EPI) y se asfixian o agotan rápido en las pruebas prácticas.', "Se preparan sin una planificación progresiva, entrenando 'a ciegas' y esperando tener suerte el día de la evaluación."].map((problem, i) => <div key={i} className="flex items-start gap-4 bg-red-950/20 border border-red-900/30 p-4 rounded-lg" data-id="element-21">
              <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-22" />
              <p className="text-slate-300" data-id="element-23">{problem}</p>
            </div>)}
        </div>
      </section>

      {/* MODULOS */}
      <section className="max-w-3xl mx-auto px-4 py-12" data-id="element-24">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-25">
          ¿Qué vas a encontrar adentro?
        </h3>
        <p className="text-center text-[#f0b429] font-semibold mb-8 uppercase tracking-wider" data-id="element-26">
          BLOQUE 1 — INGRESO
        </p>

        <div className="space-y-2 mb-12" data-id="element-27">
          <Accordion title="Módulo 1 — Diagnóstico y punto de partida del aspirante 📊" data-id="element-28">
            <ul className="list-disc pl-5 space-y-2" data-id="element-29">
              <li data-id="element-30">
                Autoevaluación inicial: test de Cooper casero, abdominales y
                flexiones en 1 minuto, carrera de 100m y 1km cronometrada
              </li>
              <li data-id="element-31">
                Cómo interpretar tus resultados frente a los estándares reales
                que exige cada federación
              </li>
              <li data-id="element-32">
                Armado de tu línea de base: planilla de registro de marcas
                iniciales
              </li>
              <li data-id="element-33">
                Errores típicos del aspirante sin estado físico previo y cómo no
                lesionarte en las primeras semanas
              </li>
              <li data-id="element-34">
                Planificación de tiempos: cuánto necesitás entrenar según la
                fecha de tu examen
              </li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 2 — Resistencia cardiovascular para Cooper, 100m y 1km 🏃‍♂️" data-id="element-35">
            <ul className="list-disc pl-5 space-y-2" data-id="element-36">
              <li data-id="element-37">
                Estructura de entrenamiento progresivo de carrera en 8-12
                semanas
              </li>
              <li data-id="element-38">
                Series específicas para mejorar el test de Cooper sin acceso a
                pista de atletismo
              </li>
              <li data-id="element-39">
                Trabajo de velocidad para los 100 metros (técnica de salida y
                arrancada)
              </li>
              <li data-id="element-40">
                Resistencia aeróbica vs. capacidad anaeróbica: por qué necesitás
                las dos
              </li>
              <li data-id="element-41">
                Adaptaciones para entrenar en espacios reducidos o sin
                equipamiento de gimnasio
              </li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 3 — Fuerza y resistencia muscular: abdominales y flexiones 💪" data-id="element-42">
            <ul className="list-disc pl-5 space-y-2" data-id="element-43">
              <li data-id="element-44">
                Progresiones para sumar repeticiones reales en el tiempo del
                examen (no "hasta el fallo")
              </li>
              <li data-id="element-45">
                Variantes de flexiones y abdominales con y sin elementos caseros
              </li>
              <li data-id="element-46">
                Frecuencia y volumen semanal sin generar sobreentrenamiento
                previo al examen
              </li>
              <li data-id="element-47">
                Corrección de técnica para que la repetición sea válida ante el
                evaluador
              </li>
              <li data-id="element-48">Plan de choque de últimas 2 semanas antes de la prueba</li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 4 — Fuerza funcional aplicada a tareas reales de bombero 🚒" data-id="element-49">
            <ul className="list-disc pl-5 space-y-2" data-id="element-50">
              <li data-id="element-51">
                Arrastre de manguera cargada: ejercicios que replican el gesto
                técnico exacto
              </li>
              <li data-id="element-52">
                Carga y traslado de equipo pesado (escalera, motobomba, mochila
                ERA)
              </li>
              <li data-id="element-53">Trepa de escalera y desplazamiento con carga</li>
              <li data-id="element-54">
                Arrastre de víctima (técnica de rescate y fuerza de tren
                superior/espalda)
              </li>
              <li data-id="element-55">
                Apertura forzada de puertas/herramientas hidráulicas: trabajo de
                agarre y tren superior
              </li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 5 — Entrenamiento con EPI y bajo estrés simulado 🧯" data-id="element-56">
            <ul className="list-disc pl-5 space-y-2" data-id="element-57">
              <li data-id="element-58">
                Cómo entrenar con peso extra simulando el equipo estructural
                completo
              </li>
              <li data-id="element-59">
                Acondicionamiento al calor y a la restricción respiratoria
                (simulación de ERA)
              </li>
              <li data-id="element-60">
                Circuitos de esfuerzo corto-intenso con recuperación incompleta
                (réplica de intervención real)
              </li>
              <li data-id="element-61">Trabajo de respiración y control bajo presión física</li>
              <li data-id="element-62">
                Errores de quienes entrenan "fuerte" pero no "específico" y
                fallan en la prueba práctica
              </li>
            </ul>
          </Accordion>
        </div>

        <p className="text-center text-[#f0b429] font-semibold mb-8 uppercase tracking-wider" data-id="element-63">
          BLOQUE 2 — SERVICIO ACTIVO
        </p>

        <div className="space-y-2" data-id="element-64">
          <Accordion title="Módulo 6 — De aspirante a bombero activo: la transición física 🔄" data-id="element-65">
            <ul className="list-disc pl-5 space-y-2" data-id="element-66">
              <li data-id="element-67">
                Qué cambia en tu entrenamiento una vez que entrás al cuerpo
                activo
              </li>
              <li data-id="element-68">
                Mantenimiento vs. pico de rendimiento: cómo no perder lo que
                lograste para el ingreso
              </li>
              <li data-id="element-69">
                Planificación de entrenamiento alrededor de guardias rotativas
                (cada 6 días)
              </li>
              <li data-id="element-70">
                Cómo sostener el hábito cuando ya no hay examen que te presione
              </li>
              <li data-id="element-71">Reevaluación periódica de tu estado físico en servicio</li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 7 — Rutina semanal sostenible para el bombero en guardia ⏱️" data-id="element-72">
            <ul className="list-disc pl-5 space-y-2" data-id="element-73">
              <li data-id="element-74">
                Plan de 3-4 sesiones semanales realista para alguien con otro
                trabajo
              </li>
              <li data-id="element-75">Entrenamiento exprés para los días de poco tiempo</li>
              <li data-id="element-76">
                Cómo entrenar antes o después de una guardia de 24hs sin
                lesionarte
              </li>
              <li data-id="element-77">
                Microciclos para mantener fuerza, resistencia y movilidad sin
                sobrecargarte
              </li>
              <li data-id="element-78">
                Adaptación de la rutina según estación del año (más demanda en
                temporada de incendios)
              </li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 8 — Entrenamiento específico por escenario de intervención 🚨" data-id="element-79">
            <ul className="list-disc pl-5 space-y-2" data-id="element-80">
              <li data-id="element-81">
                Incendio estructural: demandas físicas del ingreso, búsqueda y
                evacuación con EPI completo
              </li>
              <li data-id="element-82">
                Rescate vehicular: extracción de víctima, manejo de herramientas
                hidráulicas
              </li>
              <li data-id="element-83">
                Espacios confinados: gesto técnico y control de
                ansiedad/esfuerzo en lugares reducidos
              </li>
              <li data-id="element-84">
                Incendio forestal/rural: resistencia prolongada, carga de
                mochila y desplazamiento en terreno irregular
              </li>
              <li data-id="element-85">
                Inundación y rescate acuático: demandas de tren superior y
                flotabilidad con equipo
              </li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 9 — Prevención de lesiones y movilidad articular del bombero 🧘‍♂️" data-id="element-86">
            <ul className="list-disc pl-5 space-y-2" data-id="element-87">
              <li data-id="element-88">
                Zonas de mayor riesgo según el gesto técnico (zona lumbar,
                hombros, rodillas)
              </li>
              <li data-id="element-89">Rutina de movilidad de 10 minutos pre-guardia</li>
              <li data-id="element-90">
                Fortalecimiento de zona media para protección de columna en
                arrastres y cargas
              </li>
              <li data-id="element-91">
                Cómo identificar señales de sobrecarga antes de que se
                transformen en lesión
              </li>
              <li data-id="element-92">
                Readaptación física post-lesión para volver a la actividad
                operativa
              </li>
            </ul>
          </Accordion>

          <Accordion title="Módulo 10 — Nutrición, hidratación y recuperación para turnos de guardia 🍎" data-id="element-93">
            <ul className="list-disc pl-5 space-y-2" data-id="element-94">
              <li data-id="element-95">
                Alimentación antes, durante y después de una guardia de 24hs
              </li>
              <li data-id="element-96">Hidratación en contexto de esfuerzo bajo calor y EPI</li>
              <li data-id="element-97">Snacks y comidas prácticas para llevar al cuartel</li>
              <li data-id="element-98">
                Sueño fragmentado en guardia: cómo recuperar físicamente con
                descanso irregular
              </li>
              <li data-id="element-99">
                Suplementación básica (qué sirve y qué es marketing) para
                esfuerzo físico intenso
              </li>
            </ul>
          </Accordion>
        </div>
      </section>

      {/* BONOS */}
      <section className="max-w-3xl mx-auto px-4 py-12" data-id="element-100">
        <div className="bg-[#112236] border border-[#d4a017]/30 rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-101">
          <div className="absolute top-0 right-0 bg-[#d4a017] text-[#0b1622] font-bold px-4 py-1 rounded-bl-lg text-sm" data-id="element-102">
            GRATIS POR HOY
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8 mt-4" data-id="element-103">
            Además, te llevás estos 6 Bonos Exclusivos
          </h3>

          <div className="space-y-2" data-id="element-104">
            <Accordion title="Bono 1 — Cronograma de estudio para el examen teórico 📚" data-id="element-105">
              <ul className="list-disc pl-5 space-y-2" data-id="element-106">
                <li data-id="element-107">Plan semanal de preparación distribuido por etapas</li>
                <li data-id="element-108">
                  Bloques temáticos: normativa institucional, primeros
                  auxilios/RCP, materias técnicas, uso de EPI
                </li>
                <li data-id="element-109">Hitos de repaso intermedios</li>
                <li data-id="element-110">Simulacro de examen final</li>
                <li data-id="element-111">Estructura adaptable a cualquier federación provincial</li>
              </ul>
            </Accordion>

            <Accordion title="Bono 2 — Plan de comidas para guardia de 24hs 🍱" data-id="element-112">
              <ul className="list-disc pl-5 space-y-2" data-id="element-113">
                <li data-id="element-114">Menú armado por franja horaria de guardia</li>
                <li data-id="element-115">Lista de compras semanal</li>
                <li data-id="element-116">Opciones para llevar de casa o cocinar en el cuartel</li>
                <li data-id="element-117">Pautas de hidratación durante el turno</li>
              </ul>
            </Accordion>

            <Accordion title="Bono 3 — Checklist EPI + acondicionamiento físico combinado 📋" data-id="element-118">
              <ul className="list-disc pl-5 space-y-2" data-id="element-119">
                <li data-id="element-120">
                  Progresión para entrenar con peso del equipo estructural
                </li>
                <li data-id="element-121">Señales de sobrecarga al sumar peso extra</li>
                <li data-id="element-122">Tabla de avance semana a semana</li>
                <li data-id="element-123">Pautas de seguridad para no lesionarte</li>
              </ul>
            </Accordion>

            <Accordion title="Bono 4 — Rutina exprés de 20 minutos sin equipamiento ⚡" data-id="element-124">
              <ul className="list-disc pl-5 space-y-2" data-id="element-125">
                <li data-id="element-126">Circuito completo ejecutable en el cuartel o en casa</li>
                <li data-id="element-127">Variantes según espacio disponible</li>
                <li data-id="element-128">Pensada para semanas de poco tiempo</li>
                <li data-id="element-129">Mantenimiento mínimo efectivo de fuerza y resistencia</li>
              </ul>
            </Accordion>

            <Accordion title="Bono 5 — Guía de primeros auxilios físicos para el propio bombero 🩹" data-id="element-130">
              <ul className="list-disc pl-5 space-y-2" data-id="element-131">
                <li data-id="element-132">Manejo inmediato de esguinces y calambres</li>
                <li data-id="element-133">Prevención de sobrecargas comunes en servicio</li>
                <li data-id="element-134">Cuándo volver a entrenar después de una molestia</li>
                <li data-id="element-135">Señales que requieren atención médica</li>
              </ul>
            </Accordion>

            <Accordion title="Bono Extra — Calendario Maestro de Preparación Física (8 a 12 semanas) 📅" data-id="element-136">
              <ul className="list-disc pl-5 space-y-2" data-id="element-137">
                <li data-id="element-138">
                  Integración de los Módulos 2 a 5 en una única progresión
                  semanal
                </li>
                <li data-id="element-139">
                  Fundamentos del entrenamiento (sobrecarga progresiva,
                  especificidad, periodización)
                </li>
                <li data-id="element-140">Calendario día por día de las 12 semanas</li>
                <li data-id="element-141">Adaptación a 8 o 10 semanas si el examen está más cerca</li>
                <li data-id="element-142">Señales de alarma y planilla de registro de progreso</li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>

      {/* COMPARATIVA */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-143">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-144">
          Sin bombero resuelto vs Con bombero resuelto
        </h3>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-145">
          <div className="bg-red-950/20 border border-red-900/50 rounded-xl p-6" data-id="element-146">
            <h4 className="text-red-400 font-bold text-xl mb-4 text-center" data-id="element-147">
              Sin el Plan
            </h4>
            <ul className="space-y-3" data-id="element-148">
              <li className="flex items-start gap-2" data-id="element-149">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-150" />
                <span className="text-slate-300" data-id="element-151">
                  Entrenás a ciegas sin saber si llegás a las marcas.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-152">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-153" />
                <span className="text-slate-300" data-id="element-154">
                  Riesgo alto de lesiones por mala técnica o sobrecarga.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-155">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-156" />
                <span className="text-slate-300" data-id="element-157">
                  Te cansás rápido al usar el equipo pesado.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-158">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-159" />
                <span className="text-slate-300" data-id="element-160">
                  No sabés qué comer ni cómo recuperarte en las guardias.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-161">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-162" />
                <span className="text-slate-300" data-id="element-163">
                  Ansiedad e inseguridad el día del examen.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-green-950/20 border border-green-900/50 rounded-xl p-6" data-id="element-164">
            <h4 className="text-green-400 font-bold text-xl mb-4 text-center" data-id="element-165">
              Con el Plan
            </h4>
            <ul className="space-y-3" data-id="element-166">
              <li className="flex items-start gap-2" data-id="element-167">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-168" />
                <span className="text-slate-300" data-id="element-169">
                  Plan paso a paso con objetivos claros cada semana.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-170">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-171" />
                <span className="text-slate-300" data-id="element-172">
                  Progresión segura que protege tus articulaciones.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-173">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-174" />
                <span className="text-slate-300" data-id="element-175">
                  Entrenamiento específico para rendir con el EPI completo.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-176">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-177" />
                <span className="text-slate-300" data-id="element-178">
                  Nutrición e hidratación adaptadas a turnos de 24hs.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-179">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-180" />
                <span className="text-slate-300" data-id="element-181">
                  Confianza total para superar las pruebas físicas.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* TESTIMONIOS */}
      <section className="max-w-5xl mx-auto px-4 py-12" data-id="element-182">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10" data-id="element-183">
          Lo que dicen quienes ya están adentro
        </h3>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-184">
          {[{
          name: 'Matias, 24 años',
          city: 'Buenos Aires',
          text: 'Venía rebotando en el test de Cooper. Con este plan bajé mis tiempos en 8 semanas y entré al cuartel de mi ciudad. ¡Un golazo!'
        }, {
          name: 'Lucía, 27 años',
          city: 'Córdoba',
          text: 'Me daba terror la prueba de fuerza y arrastre. El módulo de fuerza funcional me salvó. Hoy ya soy bombera voluntaria.'
        }, {
          name: 'Facundo, 31 años',
          city: 'Santa Fe',
          text: 'Laburo 9 horas por día y no sabía cómo meter el entrenamiento. La rutina para gente con poco tiempo es clave. Muy recomendado.'
        }, {
          name: 'Julieta, 22 años',
          city: 'Mendoza',
          text: 'Los profes en el cuartel me decían que me faltaba estado. Compré la guía, seguí el paso a paso y en el último examen fui la mejor de mi camada.'
        }, {
          name: 'Diego, 29 años',
          city: 'Neuquén',
          text: 'El entrenamiento con el equipo estructural simulado hizo toda la diferencia. Llegué al examen práctico sobrado de aire.'
        }].map((t, i) => <div key={i} className="bg-[#112236] p-6 rounded-xl border border-slate-700/50" data-id="element-185">
              <div className="flex gap-1 mb-3" data-id="element-186">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-[#f0b429] text-[#f0b429]" data-id="element-187" />)}
              </div>
              <p className="text-slate-300 italic mb-4" data-id="element-188">"{t.text}"</p>
              <div className="font-bold text-white" data-id="element-189">{t.name}</div>
              <div className="text-sm text-slate-400" data-id="element-190">{t.city}</div>
            </div>)}
        </div>
      </section>

      {/* CARRUSEL */}
      <section className="max-w-3xl mx-auto px-4 py-12" data-id="element-191">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-192">
          Que te vas a encontrar dentro:
        </h3>
        <Carousel data-id="element-193" />

        {/* CARTEL BONOS GRATIS */}
        <div className="mt-8 bg-[#112236] border border-[#d4a017]/40 rounded-xl p-4 md:p-5" data-id="element-194">
          <p className="flex items-center gap-2 text-[#f0b429] font-bold uppercase tracking-wide text-sm mb-3" data-id="element-195">
            <Gift className="w-5 h-5" data-id="element-196" /> Además llevate gratis con tu compra:
          </p>
          <ul className="space-y-2 text-sm md:text-base" data-id="element-197">
            <li className="flex items-start gap-2" data-id="element-198">
              <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" data-id="element-199" />
              <span className="text-slate-200" data-id="element-200">
                <span className="font-semibold text-white" data-id="element-201">
                  Bono exclusivo:
                </span>{' '}
                "Manual Anti-Guardias: Cómo mantenerte físicamente con muy poco
                tiempo".
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-202">
              <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" data-id="element-203" />
              <span className="text-slate-200" data-id="element-204">
                <span className="font-semibold text-white" data-id="element-205">
                  Bono exclusivo 2:
                </span>{' '}
                "Sistema de prevención de lesiones para bomberos".
              </span>
            </li>
          </ul>
        </div>
      </section>

      {/* OFERTA FINAL */}
      <section className="max-w-2xl mx-auto px-4 py-16 text-center" data-id="element-206">
        <div className="bg-gradient-to-b from-[#162a42] to-[#0b1622] p-8 rounded-3xl border border-[#d4a017]/50 shadow-[0_0_40px_rgba(212,160,23,0.15)] relative overflow-hidden" data-id="element-207">
          <Countdown data-id="element-208" />

          <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-209">
            Esto es todo lo que te llevás hoy
          </h3>

          <ul className="text-left space-y-3 mb-8 max-w-md mx-auto" data-id="element-210">
            {['10 Módulos completos (Bloque 1 — Ingreso y Bloque 2 — Servicio Activo)', 'Bono 1 — Cronograma de estudio para el examen teórico', 'Bono 2 — Plan de comidas para guardia de 24hs', 'Bono 3 — Checklist EPI + acondicionamiento físico combinado', 'Bono 4 — Rutina exprés de 20 minutos sin equipamiento', 'Bono 5 — Guía de primeros auxilios físicos para el propio bombero', 'Bono Extra — Calendario Maestro de Preparación Física (8 a 12 semanas)', 'Entrega inmediata en PDF + acceso de por vida'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-211">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-212" />
                <span className="text-slate-200" data-id="element-213">{item}</span>
              </li>)}
          </ul>

          <div className="mb-6" data-id="element-214">
            <span className="text-slate-400 line-through text-2xl font-medium block mb-2" data-id="element-215">
              Precio regular: $54.900
            </span>
            <div className="text-5xl md:text-6xl font-black text-white flex items-center justify-center gap-2" data-id="element-216">
              <span className="text-[#f0b429]" data-id="element-217">$</span>19.990
              <span className="text-lg text-slate-400 font-normal mt-4" data-id="element-218">
                ARS
              </span>
            </div>
          </div>

          <BuyButton className="w-full py-5 text-xl mb-6" data-id="element-219" />

          <p className="text-sm text-slate-400 flex items-center justify-center gap-2" data-id="element-220">
            <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-221" /> Pago 100%
            seguro. Acceso inmediato.
          </p>
        </div>
      </section>

      {/* FAQ / OBJECIONES */}
      <section className="max-w-3xl mx-auto px-4 py-12" data-id="element-222">
        <h3 className="text-2xl font-bold text-center text-white mb-8" data-id="element-223">
          Preguntas Frecuentes
        </h3>

        <div className="space-y-2" data-id="element-224">
          <Accordion title="¿Es para hombres y mujeres?" data-id="element-225">
            Sí, el plan está diseñado para adaptarse al nivel inicial de
            cualquier persona, sin importar su género. Las progresiones te
            permiten avanzar a tu propio ritmo.
          </Accordion>
          <Accordion title="¿Necesito ir a un gimnasio?" data-id="element-226">
            No es estrictamente necesario. Muchos ejercicios se pueden adaptar
            para hacer en casa o en un parque, aunque tener acceso a pesas ayuda
            en etapas avanzadas para simular el peso del equipo.
          </Accordion>
          <Accordion title="¿Qué pasa si ya entreno por mi cuenta?" data-id="element-227">
            Este plan te da la especificidad que tu rutina actual no tiene. Vas
            a dejar de entrenar para "verte bien" y empezar a entrenar para
            "rendir como bombero" en las pruebas exactas que te van a tomar.
          </Accordion>
          <Accordion title="¿Cómo recibo el material?" data-id="element-228">
            Al realizar el pago, te llega un correo inmediatamente con el enlace
            para descargar el PDF completo y todos los bonos en tu celular,
            tablet o computadora.
          </Accordion>
          <Accordion title="¿Sirve para cualquier provincia de Argentina?" data-id="element-229">
            Sí, los estándares físicos de ingreso suelen ser muy similares en
            todas las federaciones (test de Cooper, flexiones, abdominales,
            fuerza funcional).
          </Accordion>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-slate-800 py-12 mt-12 text-center" data-id="element-230">
        <div className="flex items-center justify-center gap-2 text-slate-400 mb-4" data-id="element-231">
          <Settings className="w-5 h-5" data-id="element-232" />
          <span data-id="element-233">Soporte: EbookDreamShop@gmail.com</span>
        </div>
        <p className="text-slate-600 text-sm" data-id="element-234">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}